const FieldKeyConstants = {
  /** Names */
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  FIRST_NAME_PHONETIC: 'firstNamePhonetic',
  LAST_NAME_PHONETIC: 'lastNamePhonetic',
  SECOND_LAST_NAME: 'secondLastName',
  DATE_OF_BIRTH: 'birthDate',
  PREFERRED_LANGUAGE: 'preferredLanguage',

  /** Address */
  ADDRESS_LINE1: 'address1',
  ADDRESS_LINE2: 'address2',
  ADDRESS_LINE3: 'address3',
  CITY: 'cityName',
  POSTAL_CODE: 'zipCode',
  HOUSE_NUMBER: 'houseNumber',
  STATE: 'state',
  COUNTRY_CODE: 'countryCode',

  /** Contact */
  EMAIL: 'username',
  MOBILE_NUMBER: 'mobile',
  LANDLINE_NUMBER: 'landline',

  /** Equivalents of GOVERNMENT_ID */
  SSN_NUMBER: 'socialSecurityNumber',
  FISCAL_CODE: 'fiscalCode',
  TAX_CODE: 'taxId.documentNumber'
};

export default FieldKeyConstants;
